import createIcon from '../../createIcon';

/**
 * @component @name CallReceived
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkuNSA1LjkxTDE4LjA5IDQuNUw2LjUgMTYuMDlWOS41SDQuNVYxOS41SDE0LjVWMTcuNUg3LjkxTDE5LjUgNS45MVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const CallReceived = createIcon('CallReceived', [
  [
    'path',
    { d: 'M19.5 5.91L18.09 4.5L6.5 16.09V9.5H4.5V19.5H14.5V17.5H7.91L19.5 5.91Z', key: '6a6bdt' },
  ],
]);

export default CallReceived;
